import { UpaService, UpaTarget } from './../../services/upa.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ScrollService } from 'projects/common/services/scroll.service';
import { DescriptionDetailedCategory } from '../description-detailed/description-detailed-category.component';
import { ModalService } from '@shopping-angular-components/modal';
import { ModalData } from '@shopping-angular-components/modal/lib/models/ModalData.model';
import { Video } from '../video-player/video.model';
import { VideoPlayerService } from '../../services/video-player.service';
import { BrowserStorageModel } from "../../model/ModuleModel";

export interface ButtonOptions {
  // button => -primary | -secondary | -disable | -link | -white | -dark
  // ghostButton => -darken | -lighten | -disable | -white-loyalty
  type: string;
  // -lg | -md | -sm
  size?: string;
  link?: string;
  scroll_target?: boolean;
  link_text?: string;
  loader_text?: string;
  icon?: string;
  circle?: boolean;
  next?: boolean;
  ghost_button?: boolean;
  text_align?: string;
  full_width?: boolean;
  as_span?: boolean;
  modal?: Modal;
  video_playlist?: Video;
  form_type?: string;
  seconds_to_sleep?: number;
  target?: string;
  browser_storage?: BrowserStorageModel;
  stop_propagation?: boolean;
}

export interface Modal {
  modal_title: string;
  title: string;
  sub_title: string;
  text: string;
  category: DescriptionDetailedCategory;
}

@Component({
  selector: 'eva-button',
  template: `
    <optional-link
      [ngClass]="{'-eva-3-fwidth': options.full_width}"
      [link]="disableHref ? '' : options.as_span || options.scroll_target ? '' : options.link"
      [scrollTarget]="!options.as_span && options.scroll_target ? options.link : ''"
      [noFollow]="nofollow"
      [newTab]="newTab" [target]="options.target"
      [overrideClickHandler]="clickHandler">

      <button content *ngIf="!options.type || options.type !== 'none'"
        class="{{options.size ? options.size : '-md'}} {{options.type ? options.type : '-primary'}} {{options.full_width ? '-eva-3-fwidth' : ''}}"
        [ngClass]="{'-circle': options.circle, 'eva-3-btn-ghost': options.ghost_button, 'eva-3-btn': !options.ghost_button, '-loading': showLoading}"
        [name]="options.link_text" [disabled]="disabled">

        <i *ngIf="options.icon" class="btn-icon eva-3-icon-{{options.icon}} {{iconSizeClass}}"></i>
        <em *ngIf="options.link_text" class="btn-text" [innerHTML]="options.link_text"></em>
        <em class="btn-status">{{options.loader_text ? options.loader_text : ('common.loading' | translate)}}</em>
        <i *ngIf="options.next" class="btn-icon eva-3-icon-chevron-right"></i>
      </button>

      <span content *ngIf="options.type === 'none'" class="eva-3-link">
        <em class="btn-text" [innerHTML]="options.link_text"></em>
        <i *ngIf="options.icon" class="btn-icon eva-3-icon-{{options.icon}} -eva-3-pl-xsm"></i>
      </span>
    </optional-link>
  `,
  styleUrls: ['./eva-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EvaButtonComponent implements OnInit {
  @Input() moduleId: string;
  @Input() uniqueId?: string;
  @Input() moduleIndex: number;
  @Input() position: number;
  @Input() options: ButtonOptions;
  @Input() nofollow: boolean;
  @Input() newTab = false;
  @Input() modalData: ModalData;
  @Input() disableHref: boolean;
  @Input() upaData: any;
  @Input() disabled: boolean = false;

  @Input() showLoading: boolean;

  @Output() clickEvent = new EventEmitter<void>();

  invalidTrackingFields: { [key: string]: string } = {};
  iconSizeClass: string;

  constructor(private upaService: UpaService,
    private modalService: ModalService,
    private videoPlayerService: VideoPlayerService) { }

  ngOnInit(): void {
    if (this.options && this.options.circle && this.options.icon) {
      this.iconSizeClass = "-eva-3-icon" + (this.options.size ? this.options.size : '-md');
    } else {
      this.iconSizeClass = "";
    }
  }

  clickHandler = ($event) => {
    if (this.options.stop_propagation) {
      $event.stopPropagation();
    }

    if (this.hasValidTrackingInfo()) {
      let dataToTrack = {
        ...{
          label: this.options.link_text,
          moduleId: this.moduleId,
          moduleIndex: this.moduleIndex,
          uniqueId: this.uniqueId,
          positionIndex: this.position,
          target: UpaTarget.BUTTON,
          href: !this.disableHref ? this.options.link : "-"
        }, ...this.upaData
      };
      this.upaService.trackClickTopic(dataToTrack);
    } else {
      let errorMessages: string[] = []
      Object.keys(this.invalidTrackingFields).forEach(key => {
        errorMessages.push(key + ": " + this.invalidTrackingFields[key]);
      })
      console.error("Cannot track properly in EvaButtonComponent, cause: " + errorMessages.join(" | "));
    }

    if (this.options.scroll_target && this.options.link) {
      ScrollService.scrollTo(this.options.link);

    } else if (this.options.video_playlist) {
      this.videoPlayerService.show({
        uniqueId: this.uniqueId,
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        positionIndex: this.position,
      }, this.options.video_playlist)

    } else if (this.modalData) {
      this.modalService.showModal(this.modalData);
    }

    if (this.options.browser_storage) {
      const storage = this.options.browser_storage.storage_type == 'LOCAL' ? localStorage : sessionStorage;
      storage.setItem(this.options.browser_storage.key, this.options.browser_storage.value);
    }

    this.clickEvent.emit($event);
  }

  private hasValidTrackingInfo(): boolean {
    if (!this.moduleId || this.moduleId == "") {
      this.invalidTrackingFields["moduleId"] = "Property moduleId cannot be null or empty";
    }
    return Object.keys(this.invalidTrackingFields).length == 0;
  }
}
